"use client";

import YouTube from "react-youtube";
import {
  useYoutubeVideo,
  type UseYoutubeVideoProps,
} from "./use-youtube-video";

export type YoutubeVideoProps = UseYoutubeVideoProps;

function YoutubeVideo(props: YoutubeVideoProps) {
  const { className, containerClassName, youtubeId, styles } =
    useYoutubeVideo(props);

  if (!youtubeId) {
    return null;
  }

  return (
    <YouTube
      className={styles.video({ className: containerClassName })}
      iframeClassName={styles.base({ className })}
      opts={{
        host: "https://www.youtube-nocookie.com",
        playerVars: {
          color: "white",
          iv_load_policy: 3,
          rel: 0,
        },
      }}
      videoId={youtubeId}
    />
  );
}

export default YoutubeVideo;
